import callApi from "@web-monorepo/infra/callApi";
import { APIRequestBody } from "@web-monorepo/shared/api/apiTypesHelper";

type FeatureName = APIRequestBody<"/api/beyond/usage", "post">[number]["feature"];

export async function sendUsage(featureName: FeatureName) {
  await callApi({
    method: "POST",
    path: "/api/beyond/usage",
    body: [{ feature: featureName }],
  });
}

export async function fetchQuota() {
  const { body: quota } = await callApi({
    path: "/api/beyond/quota",
  });
  return quota;
}
